import { Box, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import BriaInput from "../../../../../components/common/BriaInput/BriaInput";
import ConfirmationPopup from "../../../../../components/common/ConfirmationPopup/ConfirmationPopup";
import { useAppStore } from "../../../../../hooks/useStores";
import InputLayout from "../../../../../layout/InputLayout/InputLayout";
import styles from "./CreateTgModelPopup.module.scss";

type CreateTgModelPopupProps = {
	open: boolean;
	onClose: () => void;
	handleCreateModelAndStartTraining: (datasetName?: string) => void;
};

const CreateTgModelPopup = ({ open, onClose, handleCreateModelAndStartTraining }: CreateTgModelPopupProps) => {
	const { t } = useTranslation("tg", { keyPrefix: "models.popups.create" });
	const { tgStore } = useAppStore();
	const { tgModelStore, tgDatasetStore } = tgStore;
	const [datasetName, setDatasetName] = useState(tgDatasetStore.datasetForm.name);
	const loadingCreate = tgModelStore.loadingCreateModel || tgModelStore.loadingStartTraining;

	const validateForm = !tgModelStore.modelForm.name || !datasetName;

	useEffect(() => {
		setDatasetName(tgDatasetStore.datasetForm.name);
	}, [tgDatasetStore.datasetForm.name]);

	return (
		<ConfirmationPopup
			open={open}
			title={t("title")}
			description={
				<Box className={styles.form}>
					<Typography className={styles.description}>{t("description")}</Typography>
					<InputLayout label={t("form.name.label")}>
						<BriaInput
							placeholder={t("form.name.placeholder")}
							value={tgModelStore.modelForm.name}
							onChange={(e) => tgModelStore.handleFormChange("name", e.target.value)}
						/>
					</InputLayout>
					<InputLayout label={t("form.description.label")}>
						<BriaInput
							placeholder={t("form.description.placeholder")}
							value={tgModelStore.modelForm.description}
							onChange={(e) => tgModelStore.handleFormChange("description", e.target.value)}
						/>
					</InputLayout>
					{(!tgDatasetStore.datasetForm.name || tgDatasetStore.isFormDuplicateTriggered) && (
						<InputLayout labelClassName={styles.datasetNameLabel} label={t("form.datasetName.label")}>
							<Typography className={styles.datasetNameDesc}>
								{t("form.datasetName.labelDesc")}
							</Typography>
							<BriaInput
								placeholder={t("form.datasetName.placeholder")}
								value={datasetName}
								onChange={(e) => setDatasetName(e.target.value)}
							/>
						</InputLayout>
					)}
				</Box>
			}
			confirmButtonText={t("confirmButton")}
			disableConfirm={validateForm}
			loading={loadingCreate}
			onClick={() => handleCreateModelAndStartTraining(datasetName)}
			onClose={onClose}
		/>
	);
};

export default observer(CreateTgModelPopup);
